import { useEntityList } from '@/shared/hooks/useEntityList';
import type { RootState } from '@/store';
import { fetchPaymentRetries, setFilters, setPage, setPerPage } from '../store/slice';
import type { PaymentRetry, PaymentRetryFilters } from '../types';

export const usePaymentRetries = () => {
  const result = useEntityList<PaymentRetry, PaymentRetryFilters>({
    selector: (state: RootState) => state.paymentRetries,
    fetchAction: fetchPaymentRetries,
    deleteAction: () => Promise.resolve(),
    setPageAction: setPage,
    setPerPageAction: setPerPage,
    setFiltersAction: setFilters,
    defaultFilters: {
      search: '',
      dateRange: null,
      shopifyCustomerId: '',
    },
    entityName: 'Payment Retry',
  });

  return {
    paymentRetries: result.items,
    loading: result.loading,
    error: result.error,
    page: result.currentPage,
    perPage: result.perPage,
    totalPages: result.lastPage,
    total: result.total,
    filters: result.filters,
    handlePageChange: result.handlePageChange,
    handlePerPageChange: result.handlePerPageChange,
    handleFiltersChange: result.handleFiltersChange,
    handleClearFilters: result.handleClearFilters,
  };
};
